import { defineMessages } from 'react-intl'

const scope = `procurify.components.BudgetCategoryAttributeDescriptions`

export default defineMessages({
  sourceOfTruthLabel: {
    id: `${scope}.sourceOfTruthLabel`,
    defaultMessage: 'Source of truth',
  },
  yesText: {
    id: `${scope}.yesText`,
    defaultMessage: 'Yes',
  },
  noText: {
    id: `${scope}.noText`,
    defaultMessage: 'No',
  },
})
